"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TeamChatOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TeamChatOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1c.551 0 1 .449 1 1v4c0 .551-.449 1-1 1H5.828c-.668 0-1.296.26-1.768.732L3 8.792V8a1 1 0 0 0-1-1c-.551 0-1-.449-1-1V2c0-.551.449-1 1-1h7Zm0-1H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v1.999a.5.5 0 0 0 .854.353L4.767 8.44A1.5 1.5 0 0 1 5.827 8H9a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm5 5.5h-1.5a.5.5 0 1 0 0 1H14a1 1 0 0 1 1 1v4.04c0 .554-.466.95-1.02.96a1 1 0 0 0-.98 1v.792l-1.06-1.06a2.5 2.5 0 0 0-1.768-.732H7a1 1 0 0 1-1-1V9.94a.5.5 0 1 0-1 0v1.56a2 2 0 0 0 2 2h3.173a1.5 1.5 0 0 1 1.06.44l1.913 1.912A.5.5 0 0 0 14 15.5V13.5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TeamChatOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TeamChatOutline;
exports["default"] = _default;